import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaseStudyOtherContentComponent } from './case-study-other-content.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [CaseStudyOtherContentComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [CaseStudyOtherContentComponent]
})
export class CaseStudyOtherContentModule { }
